import { HttpClient } from '@angular/common/http';
import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import { Router } from "@angular/router";
import { firstValueFrom } from 'rxjs';
import { DashboardService } from '../../lib/services/dashboard/dashboard.service';
import { ToastService } from '../../lib/services/toast/toast.service';
import { Balance, ContractDetails, Contracts, OrganizeContractRequest, SingleContract } from '../../lib/models/contracts';
import { UserUtilsService } from '../../lib/services/user/user-utils.service';
import { StorageKeysEnum } from '../../lib/storage/storage-keys.enum';
import { UserInfo } from '../../lib/models/user-info.model';
import * as pubsub from 'pubsub-js'
import { LoadingService } from '../../lib/services/loading/loading.service';
import { ContractsUtils } from '../../lib/user/contracts/contracts.utils';
import { TranslateService } from '@ngx-translate/core';
import { command } from '../../layout/sidebar/menu';
import { environment } from "../../../environments/environment";
import { ContractDeatilsModalService } from '../../lib/services/dashboard/contract-details-modal.service';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalsService } from '../../lib/services/modals/modals.service';
import { NpsService } from "../../lib/services/nps/nps.service";
import {TextUtils} from "../../lib/services/utils/text-utils.service";
import {PendingAuthorizationsService} from "../../lib/services/pending-autorizations/pending-authorizations.service";
import {AuthService} from "../../lib/services/auth/auth.service";
import {JointlyService} from "../../lib/services/jointly/Jointly.service";
import {FraudProtectionService} from "../../lib/services/fraud-protection/fraud-protection.service";

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {

    contracts!: Contracts;
    pictures: string[] = []
    contractSelected!: UserInfo | undefined;
    contractOrderList: OrganizeContractRequest[] = []
    currentIndexPosition: number = 0;
    currentIndexStartPosition: number = 0;
    loading: boolean = false;
    allContracts: UserInfo[] = [];
    translation: any;
    contractsCopy: SingleContract[] = []
    contractInformation!: ContractDetails;
    contractDetailsModalRef!: NgbModalRef
    displayModal: boolean = false
    alias: string = "";
    isDraggable: boolean = true
    loadingAlias: boolean = false
    loadingDots: boolean = false
    originalAlias: string = ""
    showPendingAuthorizationModal = false;
    readonly modalStorageKey = 'MODAL_DISPLAYED'
    pendingAuthPayments: any;
    pendingAuthRecipients: any;
    pendingAuthPaymentMancomunado: any;
    showPhraseAndImgModal: boolean = false
    showPhraseImgSuccessModal: boolean = false
    modalObserver: MutationObserver

    constructor(
        private route: Router,
        private http: HttpClient,
        private dashboardService: DashboardService,
        private toastService: ToastService,
        private userUtilsService: UserUtilsService,
        private loadingService: LoadingService,
        private contractUtils: ContractsUtils,
        private translateService: TranslateService,
        private detailsModalService: ContractDeatilsModalService,
        private modalsService: ModalsService,
        public npsService: NpsService,
        public textUtils: TextUtils,
        private pendingPaymentsService: PendingAuthorizationsService,
        private auth: AuthService,
        private jointlyService: JointlyService,
        private fraudProtectionService: FraudProtectionService
    ) {
        this.pictures = [
            `${environment.homeUrl}/assets/images/banner-monex.svg`,
            `${environment.homeUrl}/assets/images/banner-monex.svg`,
            `${environment.homeUrl}/assets/images/banner-monex.svg`,
        ]
    }

    async ngOnInit(): Promise<void> {
        const jwtWso2Decode: string | null = sessionStorage.getItem('JWT_WSO_DECODE');
        const userId = this.userUtilsService.getPersonId();
        this.npsService.getNps(userId)
        this.getAllDashboardContracts()
        await this.handleTranslation()

        this.allContracts = this.contractUtils.getContractsByServices()
        this.settingContractsOrder(this.contracts.contracts)

        this.dashboardService.contractEvent$.subscribe(value => this.handleSubscription(value))
        const userInfo = this.userUtilsService.getUserInfoSessionStorage()
        this.contractSelected = Array.isArray(userInfo?.contrato) ? userInfo?.contrato[0] : userInfo.contrato;
        const contract = this.dashboardService.getCurrentContract()?.idContrato || this.contractSelected?.idContrato || this.allContracts[0].idContrato
        this.changeContract(contract)
        this.balanceSelected(0)
        this.registerPhraseImgModal()
        if (!this.showPhraseAndImgModal) {
            this.hasSeenModal()
        }

        command(0)
        pubsub.subscribe("changeLanguage", async (msg: any, data: any) => {
            await this.handleTranslation()
        })
        await this.getPendingPayments()
        await this.getJointlyContracts()
    }

    registerPhraseImgModal() {
        const jwtWso2Decode = sessionStorage.getItem('JWT_WSO_DECODE');
        if (jwtWso2Decode) {
            let userObject = JSON.parse(jwtWso2Decode)
            //userObject!.newUser = 'true'
            if ('newUser' in userObject) {
                if (userObject!.newUser.toString() == "true") {
                    this.showPhraseAndImgModal = true;
                    this.displayModal = false;
                    this.showPendingAuthorizationModal = false;
                }
            }
        }
    }

    hasSeenModal() {
        const hasSeen = sessionStorage.getItem(this.modalStorageKey)
        if (!(hasSeen == 'true')) {
            pubsub.subscribe("closeGenericModal", async (msg: any, data: any) => {
                this.closeWelcomeModal()
            })
            this.validPendingPayments()
            const mesg = `<p class="d-inline">${this.translation.TEXT_1_MONEX}</p> <strong class="b-strong">${this.translation.TEXT_2_MONEX}</strong> <p class="d-inline">${this.translation.TEXT_3_MONEX}</p><strong class="b-strong"> ${this.translation.TEXT_4_MONEX}</strong><p class="d-inline">. ${this.translation.TEXT_5_MONEX}</p>`;
            const title = this.translation.MONEX_TITLE
            this.showPendingAuthorizationModal = false
            this.modalsService.open([], '', false, true, title, mesg, '', 'lg')
            this.displayModal = true
        }
    }

    closeWelcomeModal() {
        this.displayModal = false
        sessionStorage.setItem(this.modalStorageKey, 'true')
        this.validPendingPayments()
    }

    async handleTranslation() {
        this.translation = await firstValueFrom(this.translateService.get([
            "TOAST_MAX_LENGTH_ERROR",
            "ALIAS_CHARACTERS_ERROR",
            "TOAST_LENGTH_ERROR",
            "ALIAS_ERROR",
            "ALIAS_SUCCESS",
            "MONEX_TITLE",
            "REORGANIZE_ERROR",
            "ORGANIZE_ERROR",
            "GET_INFORMATION_ERROR",
            "CONTRACT_ERROR_GET",
            "NO_BALANCES",
            "TEXT_1_MONEX",
            "TEXT_2_MONEX",
            "TEXT_3_MONEX",
            "TEXT_4_MONEX",
            "TEXT_5_MONEX"
        ]))
    }

    handleSubscription(value: UserInfo | undefined) {
        this.contractSelected = value;
        this.dashboardService.setCurrentContract(value)
    }

    onDragLeave(event: DragEvent, index: number) {
        this.currentIndexPosition = index;
    }

    onDragStart(event: DragEvent, index: number) {
        this.currentIndexStartPosition = index;
    }

    async onDragend(event: DragEvent, index: number, contract: SingleContract) {
        if (this.currentIndexPosition !== index) {
            const currentItemIndex = this.contractOrderList.findIndex(x => x.contractId === contract.contractId)
            if (currentItemIndex !== -1) {
                this.contractOrderList[this.currentIndexStartPosition].position = this.currentIndexPosition + 1;
                this.contractOrderList[this.currentIndexPosition].position = this.currentIndexStartPosition + 1
            }
        }
        await this.organizeContracts()
        await this.getAllDashboardContractsAPI()
        this.getAllDashboardContracts()
        this.settingContractsOrder(this.contracts.contracts)
    }

    async getAllDashboardContractsAPI(): Promise<any> {
        this.loadingService.show()
        let res
        try {
            res = await firstValueFrom(this.dashboardService.getAllContracts());
            this.dashboardService.setContracts(res);
            this.loadingService.hide()
        } catch (error) {
            console.log(error);
            this.loadingService.hide()
            const msg = await firstValueFrom(this.translateService.get("CONTRACT_ERROR_GET"))
            this.toastService.showToast(msg, "error", "Error");
            return;
        }
    }

    async getAllDashboardContracts(): Promise<any> {
        this.contracts = this.dashboardService.getContracts()

        this.contractsCopy = this.contracts.contracts
        this.contractsCopy.forEach((value) => {
            value.isOpen = false,
                value.editOpen = false
        })
    }

    async organizeContracts() {
        this.loadingService.show()
        try {
            await firstValueFrom(this.dashboardService.organizeContracts(this.contractOrderList))
            this.loadingService.hide()
            return
        } catch (error) {
            console.log(error)
            this.loadingService.hide()
            this.toastService.showToast(this.translation.ORGANIZE_ERROR)
            return
        }
    }

    settingContractsOrder(contracts: SingleContract[]) {
        this.contractOrderList = []
        for (let i = 0; i < contracts.length; i++) {
            this.contractOrderList.push({
                contractId: contracts[i].contractId,
                position: i + 1
            })
        }
    }

    showBalances(currentContract: SingleContract, balances: Balance[]) {

        if (!(balances && balances.length == 0)) {
            currentContract.isOpen = !currentContract.isOpen
            this.balanceSelected(0)
            return
        }
        this.toastService.showToast(`${this.translation.NO_BALANCES} ${currentContract.idReferenceContract}`)
    }

    balanceSelected(index: number) {
        this.contractsCopy.forEach(contract => {
            contract.balances.forEach((balance, i) => {
                balance.isSelected = false;
                if (index === i) {
                    balance.isSelected = true;
                }
            });
        });
    }

    changeContract(contractId?: any) {
        this.contractSelected = this.allContracts.find(x => x.idContrato == contractId)
        const userInfo = this.userUtilsService.getUserInfoSessionStorage()
        const newInfo = sessionStorage.setItem(StorageKeysEnum.USER_INFO, JSON.stringify({
            ...userInfo,
            contrato: this.contractSelected,
        }));
        this.dashboardService.updateContract(this.contractSelected)
        pubsub.publish("contract", this.contractSelected)
    }

    async getContractInformation(contractId: number, idReferenceContract: any) {
        this.loadingDots = true
        try {
            this.contractInformation = await firstValueFrom(this.dashboardService.getAccuntDataInformation(contractId));
            this.loadingDots = false
            this.contractDetailsModalRef = this.detailsModalService.open(this.contractInformation, contractId, idReferenceContract)
        } catch (error) {
            console.log(error)
            this.loadingDots = false
            // this.toastService.showToast()
            return
        }
    }

    redirectToDynamic() {
        window.open('https://consultadinamica.monex.com.mx/', '_blank')
    }

    redirectToCurrentB() {
        window.open(environment.bancaDigitalPage, '_blank')
    }

    onCloseNpsNextQuestion() {
        this.npsService.showNps = false;
    }

    editSelected(contract: SingleContract) {
        this.originalAlias = contract.alias
        contract.editOpen = true
        this.isDraggable = false
    }

    closeEditSelected(contract: SingleContract) {
        contract.editOpen = false
        contract.alias = this.originalAlias
        this.originalAlias = ""
        this.isDraggable = true
    }

    async sendEditUser(contract: SingleContract) {
        if (contract.alias.length < 6) {
            const toastLenght = this.translation.TOAST_LENGTH_ERROR
            this.toastService.showToast(toastLenght, "warn", "Alias")
            return
        }

        if (contract.alias.length > 30) {
            const toastLenght = this.translation.TOAST_MAX_LENGTH_ERROR
            this.toastService.showToast(toastLenght, "warn", "Alias")
            return
        }

        if (!contract.alias.match(/^[a-zA-Z0-9._\s-]+$/)) {
            const toastLenght = this.translation.ALIAS_CHARACTERS_ERROR
            this.toastService.showToast(toastLenght, "warn", "Alias")
            return
        }

        this.loadingAlias = true
        try {
            await firstValueFrom(this.dashboardService.changeAliasApiCall(contract))
        } catch (error) {
            const msg = this.translation.ALIAS_ERROR
            contract.alias = this.originalAlias
            contract.editOpen = false
            this.loadingAlias = false
            console.log(error);
            this.toastService.showToast(msg, "error", "Alias")
            return
        }
        this.loadingAlias = false
        const msg = this.translation.ALIAS_SUCCESS
        contract.editOpen = false
        this.toastService.showToast(msg, "success", "Alias")
    }

    capitalizeWord(text: string) {
        return text.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
    }

    onClosePendingAuthorizationModalEvent() {
        this.showPendingAuthorizationModal = false;
    }

    async getPendingPayments() {
        await this.pendingPaymentsService.getPendingAuthorizations().subscribe({
            next: (data: any) => {
                this.pendingAuthPayments = data.pagos != "" ? data.pagos : "";
                this.pendingAuthRecipients = data.destinatarios != "" ? data.destinatarios : "";
                this.pendingAuthPaymentMancomunado = data.pagosMancomunados != "" ? data.pagosMancomunados : "";
                this.validPendingPayments()
            },
            error: (err: any) => {
                this.validPendingPayments()
                console.log(err)
            }
        })
    }


    private validPendingPayments() {
        //console.log(this.pendingAuthPayments)
        const shouldShowModal =
            !this.displayModal &&
            !this.showPhraseAndImgModal &&
            ((this.pendingAuthPayments != "" && this.pendingAuthPayments != undefined) ||
                (this.pendingAuthRecipients != "" && this.pendingAuthRecipients != undefined) ||
                (this.pendingAuthPaymentMancomunado != "" && this.pendingAuthPaymentMancomunado != undefined));

        this.showPendingAuthorizationModal = shouldShowModal && !this.showPhraseAndImgModal;
    }

    onCloseModalEvent() {
        this.showPhraseAndImgModal = false;
    }

    onCloseModalSuccessEvent() {
        this.showPhraseImgSuccessModal = false;
        this.validPendingPayments()
    }

    onModalSuccess() {
        this.showPhraseAndImgModal = false;
        this.showPhraseImgSuccessModal = true;
    }

    ngAfterViewInit() {
        this.modalObserver = new MutationObserver((mutation) => {
            setTimeout(() => {
                const modal = document.querySelector('.pending-auth-modal-container')
                if (!modal && this.showPhraseAndImgModal) {
                    this.auth.logOut();
                }
            }, 1000)

        })
        this.modalObserver.observe(document.body, {childList: true, subtree: true})
    }

    ngOnDestroy() {
        if (this.modalObserver) {
            this.modalObserver.disconnect();
        }
    }

    async getJointlyContracts() {
        await this.jointlyService.getJointlyContracts().subscribe({
            next: (data: any) => {
                sessionStorage.setItem(StorageKeysEnum.CONTRACTS_FACMAN, data.contracts);
            },
            error: (err: any) => {
                const msg = this.translation.JointlyContractsError
                this.toastService.showToast(msg, "error", "Error")
            }
        })
    }
}
